import {API} from "@/Composables/api";

const getTags = async (params = {}) => {
    return API.get(route("admin.tags.index"), params);
};

const getTag = async (tag) => {
    return API.get(route("admin.tags.show", tag));
};

const storeTag = async (tag, params = {}) => {
    return API.post(route("admin.tags.store"), params, tag);
};

const updateTag = async (tag, params = {}) => {
    return API.put(route("admin.tags.update", tag), params, tag);
};

export {getTags, getTag, storeTag, updateTag};
